<template>
  <div v-if="isLoading" class="row">
    <div class="col">
      <FontAwesomeIcon icon="fa-solid fa-spinner" spin />
      <span class="ms-2">analyzing...</span>
    </div>
  </div>
  <div v-else>
    <div class="row mt-3">
      <div class="col">
        <span class="custom-label">RO Number:</span>
        <span class="ms-2">{{ ronumber }}</span>
      </div>
      <div class="col">
        <span class="custom-label">Analyzed On:</span>
        <span class="ms-2">{{ analyzedOn }}</span>
      </div>
      <div class="col">
        <span class="custom-label">Analyzed By:</span>
        <span class="ms-2">{{ analyzedBy }}</span>
      </div>
      <div class="col custom-status">
        <span class="custom-label">Status:</span>
        <select class="form-select custom-select" v-model="status">
          <option v-for="item in statuses" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <span class="custom-label">Date:</span>
        <span class="ms-2">{{ InvoiceDate }}</span>
      </div>
      <div class="col-3">
        <span class="custom-label">PO #:</span>
        <span class="ms-2">{{ PurchaseOrder }}</span>
      </div>
      <div class="col"></div>
    </div>
    <div class="row mt-3">
      <div class="col-3"></div>
      <div class="col-2">
        <ul class="custom-list">
          <li>
            <span class="custom-label">Subtotal:</span> <span class="custom-number">{{ SubTotal }}</span>
          </li>
          <li>
            <span class="custom-label">Tax:</span> <span class="custom-number">{{ TotalTax }}</span>
          </li>
          <li class="custom-total">
            <span class="custom-label">Total:</span> <span class="custom-number">{{ InvoiceTotal }}</span>
          </li>
        </ul>
      </div>
      <div class="col"></div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { lookupStore } from '@/stores/lookup'
import { invoiceStore } from '@/stores/invoice'
import globals from '@/plugins/globals'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
export default {
  name: 'InvoiceSummary',
  components: {
    FontAwesomeIcon
  },
  data() {
    return {
      currentStatus: null,
      copiedCells: new Set() // Store copied cells
    }
  },
  emits: ['saved'],
  computed: {
    ...mapState(lookupStore, ['lookups']),
    ...mapState(invoiceStore, ['loading', 'invoice', 'invoiceDocs']),
    isLoading() {
      let _is = false
      if (this.loading) {
        if (this.loading.analysis || this.loading.invoice) {
          _is = true
        }
      }
      return _is
    },
    statuses() {
      let _statuses = []
      if (this.lookups) {
        var temp = this.lookups['Status']
        for (var i = 0; i < temp.length; i++) {
          if ([1, 2, 3, 4].includes(temp[i].value)) {
            _statuses.push({
              id: temp[i].value,
              name: temp[i].name
            })
          }
        }
      }
      return _statuses
    },
    status: {
      get() {
        let _status = ''
        if (this.invoice) {
          _status = this.invoice.status
        }
        return _status
      },
      set(value) {
        this.currentStatus = value
        this.saveInvoiceStatus()
      }
    },
    ronumber() {
      let _number = ''
      if (this.invoice) {
        _number = this.invoice.ronumber
      }
      return _number
    },
    analyzedOn() {
      let _date = ''
      if (this.invoice) {
        _date = this.formatDate(this.invoice.createdOn)
      }
      return _date
    },
    analyzedBy() {
      let _by = ''
      if (this.invoice) {
        _by = this.invoice.analyzedBy
      }
      return _by
    },
    VendorName() {
      let _data = ''
      if (this.invoiceDocs) {
        if (this.invoiceDocs.length > 0) {
          _data = this.invoiceDocs[0].Fields.VendorName ? this.invoiceDocs[0].Fields.VendorName.Content : ''
        }
      }
      return _data
    },
    InvoiceId() {
      let _data = ''
      if (this.invoiceDocs) {
        if (this.invoiceDocs.length > 0) {
          _data = this.invoiceDocs[0].Fields.InvoiceId ? this.invoiceDocs[0].Fields.InvoiceId.Content : ''
        }
      }
      return _data
    },
    InvoiceDate() {
      let _data = ''
      if (this.invoiceDocs) {
        if (this.invoiceDocs.length > 0) {
          _data = this.invoiceDocs[0].Fields.InvoiceDate ? this.invoiceDocs[0].Fields.InvoiceDate.Content : ''
        }
      }
      return _data
    },
    PurchaseOrder() {
      let _data = ''
      if (this.invoiceDocs) {
        if (this.invoiceDocs.length > 0) {
          _data = this.invoiceDocs[0].Fields.PurchaseOrder ? this.invoiceDocs[0].Fields.PurchaseOrder.Content : ''
        }
      }
      return _data
    },
    SubTotal() {
      let _data = ''
      if (this.invoiceDocs) {
        if (this.invoiceDocs.length > 0) {
          _data = this.invoiceDocs[0].Fields.SubTotal ? this.invoiceDocs[0].Fields.SubTotal.Content : ''
        }
      }
      return _data
    },
    TotalTax() {
      let _data = ''
      if (this.invoiceDocs) {
        if (this.invoiceDocs.length > 0) {
          _data = this.invoiceDocs[0].Fields.TotalTax ? this.invoiceDocs[0].Fields.TotalTax.Content : ''
        }
      }
      return _data
    },
    InvoiceTotal() {
      let _data = ''
      if (this.invoiceDocs) {
        if (this.invoiceDocs.length > 0) {
          _data = this.invoiceDocs[0].Fields.InvoiceTotal ? this.invoiceDocs[0].Fields.InvoiceTotal.Content : ''
        }
      }
      return _data
    }
  },
  methods: {
    ...mapActions(invoiceStore, ['setInvoice', 'saveStatus']),
    formatDate(date, type = 'datetime') {
      return globals.formatDate(date, type)
    },
    copy(item, content) {
      navigator.clipboard
        .writeText(content)
        .then(() => {
          // Mark the cell as copied
          this.copiedCells.add(item)
        })
        .catch((err) => console.error('Clipboard copy failed:', err))
    },
    isCopied(item) {
      return this.copiedCells.has(item)
    },
    async saveInvoiceStatus() {
      if (this.currentStatus) {
        this.setInvoice({
          name: 'status',
          value: this.currentStatus
        })
        // save
        let data = {
          invoice: this.invoice.invoice,
          status: this.currentStatus
        }
        console.log('save status', data)
        await this.saveStatus(data)
        this.$emit('saved')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-label {
  font-weight: 500;
}
.custom-invoice-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 62vh;
  padding-right: 5px;
}
.custom-status {
  display: inline-flex;
}
.custom-select {
  width: 150px;
  margin-left: 10px;
}
.custom-clipboard-copied {
  color: green !important;
}
.custom-blue {
  color: rgb(33, 33, 255);
  font-weight: 500;
  font-size: 1.1em;
}
.custom-invoice {
  border: 1px solid #ff0000;
  padding: 5px;
}
.custom-list {
  list-style-type: none;
  padding: 0;
}
.custom-total {
  border-top: 1px solid #dee2e6;
}
.custom-number {
  float: right;
}
</style>
